/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyTokenMutationVariables = {|
  token: string
|};
export type VerifyTokenMutationResponse = {|
  +verifyToken: ?{|
    +payload: ?any
  |}
|};
export type VerifyTokenMutation = {|
  variables: VerifyTokenMutationVariables,
  response: VerifyTokenMutationResponse,
|};
*/


/*
mutation VerifyTokenMutation(
  $token: String!
) {
  verifyToken(token: $token) {
    payload
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "VerifyToken",
    "kind": "LinkedField",
    "name": "verifyToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payload",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1677dfd1b95fa342712afb43ec1de31e",
    "id": null,
    "metadata": {},
    "name": "VerifyTokenMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyTokenMutation(\n  $token: String!\n) {\n  verifyToken(token: $token) {\n    payload\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bd4dc5bbe33516247907773cb7d5a497';

module.exports = node;
